// 한국 전화번호 포매터 + 검증.
// 지원 형식: 02-XXX-XXXX (9) / 02-XXXX-XXXX (10) / 0XX-XXX-XXXX (10) / 0XX-XXXX-XXXX (11)

export function formatPhoneInput(raw) {
  const digits = raw.replace(/\D/g, '').slice(0, 11);
  if (digits.length === 0) return '';

  // 서울 (02 area code)
  if (digits.startsWith('02')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    // 9자리이면 2-3-4, 그 외엔 2-4-4 (입력 중일 땐 4 우선)
    if (digits.length === 9) {
      return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    }
    return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  // 3자리 area code (010, 031, 070 등)
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  // 10자리이면 3-3-4, 11자리이면 3-4-4
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

// 유효 한국 전화번호: 0으로 시작 + 9~11자리 숫자
export function isPhoneValid(formatted) {
  const digits = formatted.replace(/\D/g, '');
  if (!digits.startsWith('0')) return false;
  return digits.length >= 9 && digits.length <= 11;
}

// (구) isPhoneComplete 호환 — 폼에서 이 이름으로 import 중일 수도 있음
export const isPhoneComplete = isPhoneValid;

// 이메일: 비어있으면 통과 (선택사항), 채워져있으면 형식 검사
export function isEmailValid(value) {
  if (!value) return true;
  return /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value);
}
